<template>
  <div class="tva-social-sharing">
    <div class="tva-social-sharing-text">Share</div>
    <social-sharing
      :url="config.url"
      :title="config.title"
      :description="config.description"
      :quote="config.quote"
      :hashtags="config.hashtag"
      :twitter-user="config.twitterUser"
      inline-template
    >
      <div>
        <network network="facebook">
          <svgicon icon="social-logo-facebook" width="20" height="20"></svgicon
          >&nbsp;
        </network>
        <network network="linkedin">
          <svgicon icon="social-logo-linkedin" width="20" height="20"></svgicon
          >&nbsp;
        </network>
        <network network="twitter">
          <svgicon icon="social-logo-twitter" width="20" height="20"></svgicon
          >&nbsp;
        </network>
      </div>
    </social-sharing>
  </div>
</template>
<script>
import "@/compiled-icons/social-logo-facebook";
import "@/compiled-icons/social-logo-twitter";
import "@/compiled-icons/social-logo-linkedin";
export default {
  props: [
    "config"
  ]
};
</script>
<style lang="scss" scoped>
.tva-social-sharing {
  display: flex;
}
</style>
